import { AutocompleteChangeReason } from "@mui/material/Autocomplete";
import { SelectItem } from "components/lbc-toolkit/molecules/Select";
import MultiSelectFreeSolo from "components/molecules/MultiSelectFreeSolo";
import getTestIDs from "lib/utils/getTestIDs";
import React, { useState } from "react";
import { SidebarTagProps } from ".";
import { InputAndButtonWrapperSC, TagCreateContainerSC } from "./styles";

export const testIDs = getTestIDs();

interface TagsInputProps {
  disabled?: boolean;
  handleAddTag: (tag: SidebarTagProps) => void;
  handleCreateTag: (tag: string) => void;
  label: string;
  selectedTags: SidebarTagProps[];
  tagOptions: SelectItem[];
}

const TagsInput: React.FC<TagsInputProps> = ({
  tagOptions,
  disabled,
  selectedTags,
  handleCreateTag,
  handleAddTag,
  label,
}) => {
  const [inputValue, setInputValue] = useState("");

  const compareIgnoreCase = (str1: string, str2: string) => str1.toLowerCase() === str2.toLowerCase();

  const selectTag = (newTag: string | SelectItem | null) => {
    if (!newTag) return;
    const label = typeof newTag === "string" ? newTag : newTag.label;
    const existingTagInList = selectedTags.find((tag) => compareIgnoreCase(tag.label, label));
    if (existingTagInList) return;

    const isCreateOption = typeof newTag !== "string" && !newTag.value;
    if (typeof newTag === "string" || isCreateOption) {
      handleCreateTag(label);
    } else {
      handleAddTag({ label: newTag.label, id: newTag.value });
    }
  };

  const onChangeAutocompleteValue = (
    event: React.SyntheticEvent<Element, Event>,
    value: Array<string | SelectItem>,
    reason: AutocompleteChangeReason
  ) => {
    if (reason !== "selectOption" && reason !== "createOption") return;
    const added = value[value.length - 1];
    selectTag(added ?? null);
    setInputValue("");
  };

  return (
    <TagCreateContainerSC>
      <InputAndButtonWrapperSC>
        <MultiSelectFreeSolo
          label={label}
          options={tagOptions}
          //   onChangeInput={(e) => setInputValue(e.target.value)}
          inputValue={inputValue}
          disabled={disabled}
          onChange={onChangeAutocompleteValue}
          //   onBlur={handleOnClickOutside}
          //   ref={textFieldRef}
          //   value={[]}
          selected={selectedTags.map((tag, index) => ({ label: tag.label, value: tag.id ?? "" }))}
        />
      </InputAndButtonWrapperSC>
    </TagCreateContainerSC>
  );
};

export default TagsInput;
